// @flow
export const BILLING_PERIODS_FETCH = 'BILLING_PERIODS_FETCH'
export const BILLING_PERIODS_SUCCESS = 'BILLING_PERIODS_SUCCESS'
export const BILLING_PERIODS_FAIL = 'BILLING_PERIODS_FAIL'
